/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Payload du panneau « CONTRAT DE MARIAGE », envoyé via `service.update`
 * (PUT `/numerisation-actes/mariage/{identifiant}`).
 *
 * ⚠️ `contratMariageExiste` est envoyé même à `false` : c'est ce qui déclenche la
 * purge de la date côté API. L'omettre laisserait une date invisible en base —
 * masquée à l'écran puisque la saisie ne la montre plus.
 *
 * ⚠️ Le NOTAIRE n'y est pas : c'est un individu du dossier, écrit par
 * `PUT /acte-individus/{id}` et enchaîné par la modale.
 *
 * @param identifiant Identifiant de l'ACTE : construit l'URL du PUT.
 * @param data État du formulaire de la modale.
 */
const buildContratMariageUpdatePayload = (
  identifiant: number,
  data: Record<string, any>,
) => ({
  identifiant,
  acte: {
    identifiant,
    contratMariageExiste: Boolean(data?.contratMariage),
    contratMariageDate: data?.dateContratMariage,
  },
});

export default buildContratMariageUpdatePayload;
